module.exports = __webpack_public_path__ + "assets/img/Singapore Polytechnic.bde838c2.jpg";